import React from 'react';
import './index.css';

export default function Propuestas() {
  return (
    <div className="propuestas">
      <h4>Propuesta de cada parada:</h4>
      <ul>
        <li><i></i><span>Obra de teatro participativa en un colectivo.</span></li>
        <li><i></i><span>Juegos educativos</span></li>
        <li><i></i><span>Shows musicales y sorteos</span></li>
        <li><i></i><span>Mateada y charla educativa</span></li>
        <li><i></i><span>Shows musicales y sorteos</span></li>
      </ul>
    </div>
  );
}
